module.exports = __webpack_public_path__ + "static/support-customers-5dc5c70a9f6c0477e60a2c610d52a728.jpg";